import React from "react";
import styled from "styled-components";
import { FontWeight, content, form, size } from "@glossy";
import { Checkable, checkable } from "@ui-kit/form/checkable";

const Marker = styled.div<Pick<Checkable, "checked">>`
  ${size(8)};
  border-radius: 4px;
  background-color: ${(props) => form(props, "include")};
`;

const Box = styled.div<Pick<Checkable, "checked">>`
  ${checkable.box};
  border-radius: 50%;
`;

const Label = styled.span<Pick<Checkable, "checked">>`
  ${checkable.label};
  font-weight: ${FontWeight.Bold};
  color: ${({ checked, ...props }) =>
    checked ? form(props, "include") : content};
`;

const Root = styled.div<Pick<Checkable, "checked" | "disabled" | "inline">>`
  ${checkable.root};
  :not(:hover) {
    ${Box} {
      opacity: ${({ checked }) => !checked && 0.5};
    }
    ${Marker} {
      visibility: ${({ checked }) => !checked && "hidden"};
    }
  }
`;

const UiKitFormRadio = ({
  label,
  checked,
  disabled,
  inline,
  onClick,
  className,
}: Checkable) => {
  const handleClick = (e) => {
    if (!disabled && onClick) {
      // Stop propagation to avoid handle twice (<label /> and <input />)
      e.preventDefault();
      e.stopPropagation();
      onClick(e, !checked);
    }
  };

  return (
    <Root {...{ checked, disabled, inline, className }} onClick={handleClick}>
      <Box checked={checked}>
        <Marker checked={checked} />
      </Box>
      {!!label && <Label checked={checked}>{label}</Label>}
    </Root>
  );
};

export default UiKitFormRadio;
